// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.video-dialog[data-v-69ca447b] .el-dialog {\n  max-width: 900px !important;\n}\n.title-style[data-v-69ca447b] {\n  font-size: 20px;\n}\n.video-style[data-v-69ca447b] {\n  width: 100%;\n  text-align: center;\n}\n.video-width[data-v-69ca447b] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
